import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

    public get getAdalConfig(): any {
        return {
            tenant: 'NETORG465099.onmicrosoft.com',
            clientId: '2671d95e-5755-460b-8967-abe4747751b2',
            redirectUri: window.location.origin + '/',
            postLogoutRedirectUri: window.location.origin + '/',
            navigateToLoginRequestUrl: false,
            isAngular: true,
            cacheLocation: 'localStorage'
        };
    }


}